import React from 'react';
import { Icon, IconName } from '@hills-design-system/components';
import Modal from './Modal';
import { ModalSize } from './Modal.types';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';

interface InvalidSoldToModalProps {
  isOpen: boolean;
}

const InvalidSoldToModal: React.FC<InvalidSoldToModalProps> = ({ isOpen }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t(TranslationKeyEnum.InvalidSoldToModalTitle)}
      isOpen={isOpen}
      onClose={() => {}} // Prevent closing this modal
      size={ModalSize.Medium}
      showCloseButton={false}
      className="max-w-2xl text-center"
    >
      <div className="space-y-6">
        <div className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>

          <div className="space-y-3">
            <p className="text-gray-700 text-base leading-relaxed">
              {t(TranslationKeyEnum.InvalidSoldToModalDescription1)}
            </p>

            <ul className="text-gray-700 text-base leading-relaxed text-start bg-gray-50 rounded-lg px-4 py-3">
              <li className="flex gap-2 items-center">
                <Icon icon={IconName.Check} size={15} className="text-primary" />{' '}
                {t(TranslationKeyEnum.InvalidSoldToModalLine1)}
              </li>
              <li className="flex gap-2 items-center">
                {' '}
                <Icon icon={IconName.Check} size={15} className="text-primary" />{' '}
                {t(TranslationKeyEnum.InvalidSoldToModalLine2)}{' '}
              </li>
            </ul>

            <p className="text-gray-700 text-base leading-relaxed">
              <strong>{t(TranslationKeyEnum.InvalidSoldToModalContactSupport)}</strong> <br />{' '}
              {t(TranslationKeyEnum.Email)}:{' '}
              <a className="text-blue-600" href="mailto:shelters@hillspet.com">
                shelters@hillspet.com
              </a>{' '}
              or{' '}
              <a className="text-blue-600" href="tel:1-866-283-1217">
                {' '}
                1-866-283-1217
              </a>{' '}
              {t(TranslationKeyEnum.InvalidSoldToModalContactDayTime)}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InvalidSoldToModal;
